module.exports = __webpack_public_path__ + "img/pic6.13b94ac0.png";